import { Box } from "@chakra-ui/react";
import Selection from "./Selection";
import Info from "./Info";
import Course from "./Course";

type Iprops = {
  children: React.ReactNode;
};

type Ivariant = {
  Selection: React.FC<SelectionProps>;
  Info: React.FC<CardInfoProps>;
  Course: React.FC<ICourseCardProps>;
};

const Card: React.FC<Iprops> & Ivariant = ({ children }) => {
  return <Box>{children}</Box>;
};

Card.Selection = Selection;
Card.Info = Info;
Card.Course = Course;

export default Card;
